import React, { useEffect, useRef, useState } from 'react'
import { Button } from 'react-bootstrap'

import { api_gateway } from '../../../conexoes/api'
import { setaDropdown } from '../../../utils/alternanciaIcones'
import Checkbox from '../../Mantine/Checkbox/index.jsx'
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js'

export default function SelectOperadoraCheckbox(props) {
  const [spinAtivo, setSpinAtivo] = useState(true)
  const [lsOperadoraCheckboxs, setLsOperadoraCheckboxs] = useState([])
  const modal = useRef()
  let todosUsuarios = []

  const handleClickFora = (e) => {
    if (!modal.current.contains(e.target)) {
      handleCancelar()
    }
  }

  function handleCancelar() {
    props.setRevelarSelectOperadoraCheckbox(false)
  }

  function handleOperadoraCheckbox(codigo, label, checkbox) {
    if (codigo === -1) {
      handleSelecionarTodos(checkbox)
    } else {
      if (checkbox === true) {
        props.arrayCdOperadora.push({
          cd_dsp_operadora: codigo,
          ds_dsp_operadora: label
        })
      } else {
        props.arrayCdOperadora.forEach(function (e, index) {
          if (codigo == e.cd_dsp_operadora) {
            props.arrayCdOperadora.splice(index, 1)
          }
        })
      }
    }
  }

  function handleSelecionarTodos(checked) {
    const length = props.arrayCdOperadora.length
    let i = 0
    while (i < length) {
      props.arrayCdOperadora.pop()
      i++
    }

    if (checked === true) {
      todosUsuarios.forEach(function (operadora) {
        props.arrayCdOperadora.push({
          cd_dsp_operadora: operadora.cd_dsp_operadora,
          ds_dsp_operadora: operadora.ds_dsp_operadora
        })
      })
    }
  }

  useEffect(() => {
    setSpinAtivo(true)
    async function renderOperadoraCheckboxs() {
      const { data } = await api_gateway.get('/m1/consultar/operadora')
      data.dados.unshift({ cd_dsp_operadora: -1, ds_dsp_operadora: 'Todos' })
      todosUsuarios = data.dados

      if (data.dados.length > 0) {
        let objetoOperadoraCheckboxs = data.dados.map((item, i) => {
          return (
            <li key={'menu-' + item.cd_dsp_operadora}>
              <div className="campo-select-opcao-checkbox campo-select-opcao-1">
                <Checkbox
                  id={'checkbox-' + item.cd_dsp_operadora}
                  key={'checkbox-' + item.cd_dsp_operadora}
                  label={item.ds_dsp_operadora}
                  defaultChecked={handleMarcarCheckboxes(item.cd_dsp_operadora)}
                  onChange={(e) =>
                    handleOperadoraCheckbox(
                      item.cd_dsp_operadora,
                      item.ds_dsp_operadora,
                      e.target.checked
                    )
                  }
                />
              </div>
              {data.dados[i + 1] != undefined && (
                <div className="campo-select-divisor-cor-1 campo-select-divisor" />
              )}
            </li>
          )
        })
        setLsOperadoraCheckboxs(objetoOperadoraCheckboxs)
      } else {
        let objetoOperadoraCheckboxs = () => {
          return (
            <li>
              <div disabled className="campo-select-opcao campo-select-opcao-1">
                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">
                  Nenhuma informação encontrada
                </span>
              </div>
            </li>
          )
        }
        setLsOperadoraCheckboxs(objetoOperadoraCheckboxs)
      }

      setSpinAtivo(false)
    }
    renderOperadoraCheckboxs()
    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)
  }, [])

  function handleMarcarCheckboxes(codigo) {
    let verificacao = false
    props.arrayCdOperadora.forEach(function (e) {
      if (codigo === e.cd_dsp_operadora) {
        verificacao = true
      }
    })
    return verificacao
  }

  return (
    <div ref={modal}>
      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      <Button
        name="cdTipoPessoa"
        className="campo-texto-cor-3 campo-select"
        onClick={() => handleCancelar()}
      >
        <div className="fonte-cor-1 label-campo">
          {props.dsOperadoraCheckbox}
        </div>
        <img
          className="campo-select-icone-ativado"
          src={setaDropdown()}
          alt="drop"
        />
      </Button>
      <div className="campo-select-triangulo-cor-1 campo-select-triangulo-position-fixed" />
      <div className="campo-texto-cor-3 campo-select-corpo-position-fixed width-180px">
        <ul className="campo-select-lista">{lsOperadoraCheckboxs}</ul>
      </div>
    </div>
  )
}
